export enum CarrierLabelErrorDictionary {
  "UNKNOWN" = "UNKNOWN",
  "INVALID_HS_CODE" = "INVALID_HS_CODE",
  "INVALID_EORI_NUMBER" = "INVALID_EORI_NUMBER",
}


